<template>
    <nav :class="['nav', { 'nav--open': navState }]">
        <div
            class="nav-closer"
            @click="navClose"
        >
            <div class="nav-closer__line nav-closer__line--left"></div>
            <div class="nav-closer__line nav-closer__line--right"></div>
        </div>
        <div class="nav-top">
            <div class="nav__ch">
                <div class="nav__ch-title">
                    <router-link to="/chapter1"> <span class="number">Chapter.1</span> <span class="title">최악의 조건</span> </router-link>
                </div>
                <div class="nav__ch-sc">
                    <router-link to="/chapter1#sc-1-1">
                        <span class="number">1-1.</span>
                        <span class="title">거대한 땔감</span>
                    </router-link>
                    <router-link to="/chapter1#sc-1-2">
                        <span class="number">1-2.</span>
                        <span class="title">두천리</span>
                    </router-link>
                    <router-link to="/chapter1#sc-1-3">
                        <span class="number">1.3</span>
                        <span class="title">전례없는 확산 속도</span>
                    </router-link>
                    <router-link to="/chapter1#sc-1-4">
                        <span class="number">1-4.</span>
                        <span class="title">산불이 달라졌다</span>
                    </router-link>
                </div>
            </div>
            <div class="nav__ch">
                <div class="nav__ch-title">
                    <router-link to="/chapter2"> <span class="number">Chapter.2</span> <span class="title">원전방어작전</span></router-link>
                </div>
                <div class="nav__ch-sc">
                    <router-link to="/chapter2#sc-2-1">
                        <span class="number">2-1.</span>
                        <span class="title">연무속으로</span>
                    </router-link>
                    <router-link to="/chapter2#sc-2-2">
                        <span class="number">2-2.</span>
                        <span class="title">한울원자력발전소</span>
                    </router-link>
                    <router-link to="/chapter2#sc-2-3">
                        <span class="number">2.3</span>
                        <span class="title">마비된 원자력 재난 시스템</span>
                    </router-link>
                    <router-link to="/chapter2#sc-2-4">
                        <span class="number">2-4.</span>
                        <span class="title">각자도생</span>
                    </router-link>
                </div>
            </div>
            <div class="nav__ch">
                <div class="nav__ch-title">
                    <router-link to="/chapter3"><span class="number">Chapter.3</span> <span class="title">일진일퇴</span></router-link>
                </div>
                <div class="nav__ch-sc">
                    <router-link to="/chapter3#sc-3-1">
                        <span class="number">3-1.</span>
                        <span class="title">우선순위</span>
                    </router-link>
                    <router-link to="/chapter3#sc-3-2">
                        <span class="number">3-2.</span>
                        <span class="title"> 불 속의 탑</span>
                    </router-link>
                    <router-link to="/chapter3#sc-3-3">
                        <span class="number">3-3.</span>
                        <span class="title">산을 감은 전력 그물망</span>
                    </router-link>
                    <router-link to="/chapter3#sc-3-4">
                        <span class="number">3-4.</span>
                        <span class="title">태세 전환 </span>
                    </router-link>
                    <router-link to="/chapter3#sc-3-5">
                        <span class="number">3-5.</span>
                        <span class="title">산불재난대응체계, 잘 작동했나</span>
                    </router-link>
                </div>
            </div>
            <div class="nav__ch">
                <div class="nav__ch-title">
                    <router-link to="/chapter4"> <span class="number">Chapter.4</span> <span class="title">잔불</span> </router-link>
                </div>
                <div class="nav__ch-sc">
                    <router-link to="/chapter4#sc-4-1">
                        <span class="number">4-1.</span>
                        <span class="title">검은 숲 속으로 </span>
                    </router-link>
                    <router-link to="/chapter4#sc-4-2">
                        <span class="number">4-2.</span>
                        <span class="title">응봉산</span>
                    </router-link>
                    <router-link to="/chapter4#sc-4-3">
                        <span class="number">4-3.</span>
                        <span class="title">비 </span>
                    </router-link>
                </div>
            </div>
            <div class="nav__ch">
                <div class="nav__ch-title">
                    <router-link to="/chapter5"> <span class="number">Chapter.5</span> <span class="title">산불, 그 후</span> </router-link>
                </div>
                <div class="nav__ch-sc">
                    <router-link to="/chapter5#sc-5-1">
                        <span class="number">5-1.</span>
                        <span class="title">컨테이너에서 </span>
                    </router-link>
                    <router-link to="/chapter5#sc-5-2">
                        <span class="number">5-2.</span>
                        <span class="title">이재민</span>
                    </router-link>
                    <router-link to="/chapter5#sc-5-3">
                        <span class="number">5-3.</span>
                        <span class="title">미국의 산불 : 과학, 스모키 베어를 변화시키다</span>
                    </router-link>
                    <router-link to="/chapter5#sc-5-4">
                        <span class="number">5-4.</span>
                        <span class="title">화마는 다시 온다</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="nav-bottom">
            웹사이트 공유하기
            <div
                class="share share--fb"
                @click="shareFacebook"
            >
                <img
                    :src="require('@/assets/imgs/facebook.svg')"
                    alt=""
                />
            </div>
            <div
                class="share share--twt"
                @click="shareTwitter"
            >
                <img
                    :src="require('@/assets/imgs/twitter.svg')"
                    alt=""
                />
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'blm-nav',
    props: ['nav-state'],
    methods: {
        navClose() {
            this.$emit('nav-close');
        },
        shareFacebook() {
            let url = encodeURIComponent('https://pages.newstapa.org/n2211_blackmountain');
            let title = '검은산: 2022년 울진 산불';
            window.open(`http://www.facebook.com/sharer.php?u=${url}&t=${title}`, '검은산: 2022년 울진 산불', 'width=400, height=400');
        },
        shareTwitter() {
            let url = encodeURIComponent('https://pages.newstapa.org/n2211_blackmountain');
            let title = '검은산: 2022년 울진 산불';
            window.open(`https://twitter.com/intent/tweet?url=${url}&text=${title}`, 'popup제목', 'width=400, height=400');
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.nav {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 999;
    width: 100%;
    max-width: 500px;
    background: black;
    color: $white;
    height: 100%;
    padding: 20px 40px;
    overflow: scroll;
    background-image: url('../assets/imgs/navback.svg');
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &__ch-title {
        font-size: 25px;
        .number {
            font-family: miller-display;
            font-size: 1.1em;
            position: relative;
            bottom: 0.05em;
            padding-right: 20px;
        }
        .title {
            font-weight: 600;
        }
    }
    &__ch-sc {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;
        padding-left: 35px;
        line-height: 1.3;
        gap: 5px;

        a {
            font-size: 18px;
            display: grid;
            grid-template-columns: 60px 1fr;
            border-bottom: 1px solid $white;
            span {
                display: block;
            }
            .number {
                font-family: miller-display;
                font-size: 1.2em;
                position: relative;
                bottom: 0.1em;
            }
            .title {
                align-self: center;
            }

            &:hover {
                background: $white;
                color: $black;
            }
        }
    }

    .nav-closer {
        position: fixed;
        right: 20px;
        top: 20px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-content: center;
        border: 1px solid white;
        cursor: pointer;
        transition: background 0.2s;
        background: black;
        &__line {
            height: 2px;
            background: $white;
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            &--left {
                transform: translate(-50%, -50%) rotate(135deg);
            }
            &--right {
                transform: translate(-50%, -50%) rotate(45deg);
            }
        }
        &:hover {
            background: rgb(50, 50, 50);
        }
    }
}

.nav-bottom {
    display: flex;
    justify-content: center;
    gap: 15px;
    align-items: center;
    padding-top: 20px;
    :deep(.newstapa-logo) {
        width: 80px;

        path {
            fill: white;
        }
    }

    .share {
        width: 25px;
        cursor: pointer;
        img {
            width: 100%;
            transition: opacity 0.2s;
            &:hover {
                opacity: 0.7;
            }
        }
    }
}

@media all and (max-width: 800px) {
    .nav {
        padding: 20px;
        padding-top: 13px;
        .nav-bottom {
            .newstapa-logo {
                width: 50px;
                svg {
                    width: 100%;
                }
            }
        }

        &__ch-title {
            font-size: 20px;
            margin-bottom: 10px;
        }

        &__ch-sc {
            padding-left: 0;
            a {
                font-size: 16px;
            }
        }

        .nav-closer {
            width: 25px;
            height: 25px;
            &__line {
                width: 80%;
            }
        }
    }
}
</style>
